export default {
	"DeFi Binance" : "DeFi Binance",
	"流动性挖矿" : "流动性挖矿",
	"加入节点， 开始挖矿" : "加入节点， 开始挖矿",
	"参 与" : "参 与",
	"矿池数据" : "矿池数据",
	"总产量" : "总产量",
	"有效节点" : "有效节点",
	"参与者" : "参与者",
	"用户收入" : "用户收入",
	"挖矿榜单" : "挖矿榜单",
	"流动性挖矿收入" : "流动性挖矿收入",
	"输出记录" : "输出记录",
	"地址" : "地址",
	"数量" : "数量",
	"帮助中心" : "帮助中心",
	"希望它可以帮助你" : "希望它可以帮助你",
	"安全保障" : "安全保障",
	"我们有安全的审计报告" : "我们有安全的审计报告",
	"伙伴" : "伙伴",
	"我们的商业伙伴" : "我们的商业伙伴",
	"首页" : "首页",
	"我的矿池" : "我的矿池",
	"提取" : "提取",
	"账户" : "账户",
	"总挖矿金额" : "总挖矿金额",
	"可更换" : "可更换",
	"收益率" : "收益率",
	"币池名称" : "币池名称",
	"最低金额" : "最低金额",
	"收益率/24小时" : "收益率/24小时",
	"挖矿记录" : "挖矿记录",
	"金额" : "金额",
	"描述" : "描述",
	"时间" : "时间",
	"已参与" : "已参与",
	"质 押" : "质 押",
	"已质押" : "已质押",
	"记录" : "记录",
	"兑换" : "兑换",
	"从" : "从",
	"全部" : "全部",
	"至" : "至",
	"价格" : "价格",
	"确认" : "确认",
	"矿池收益" : "矿池收益",
	"今日收益" : "今日收益",
	"普通矿池" : "普通矿池",
	"高级矿池" : "高级矿池",
	"全部的" : "全部的",
	"可用的" : "可用的",
	"申请加入" : "申请加入",
	"推荐朋友" : "推荐朋友",
	"一起赚取加密货币" : "一起赚取加密货币",
	"查看详情" : "查看详情",
	"团队" : "团队",
	"推荐" : "推荐",
	"团队规模" : "团队规模",
	"直接发起人" : "直接发起人",
	"总收入" : "总收入",
	"今天的收入" : "今天的收入",
	"我的推荐链接" : "我的推荐链接",
	"复制" : "复制",
	"1. 获取链接" : "1. 获取链接",
	"2. 邀请朋友" : "2. 邀请朋友",
	"3. 赚取加密货币" : "3. 赚取加密货币",
	"等级" : "等级",
	"1 级" : "1 级",
	"2 级" : "2 级",
	"3 级" : "3 级",
	"用户地址" : "用户地址",
	"币种" : "币种",
	"说明" : "说明",
	"状态" : "状态",
	"定时收益" : "定时收益",
	"今日预收益" : "今日预收益",
	"累计收益" : "累计收益",
	"将矿池收益的BNB兑换成USDT后立即到账" : "将矿池收益兑换成USDT后立即到账",
	"将USDT提取后会在24小时内到达你的钱包" : "将USDT提取后会在24小时内到达你的钱包",
	"天" : "天",
	"高级矿池收益" : "高级矿池收益",
	"质押收益" : "质押收益",
	"下次收益" : "下次收益",
	"当前收益率" : "当前收益率",
	"昨日收益" : "昨日收益",
	"普通矿池收益率" : "普通矿池收益率",
	"高级矿池收益率" : "高级矿池收益率",
	"高级矿池限时开放" : "高级矿池限时开放",
	"公告":"公告",
	"我知道了":"我知道了"
};